import { Injectable } from '@angular/core';

@Injectable()
export class SessionStorageService {
    getData<T> (key: string): T {
        let text = window.sessionStorage.getItem(key);
        return text ? JSON.parse(text): '';
    }

    setData (key: string, data: any): boolean {
        let text = JSON.stringify(data);

        try {
            window.sessionStorage.setItem(key, text);
            return true;
        }
        catch(error) {
            console.log("Cannot set local storage data:");
            console.log(data);
            return false;
        }
    }

    removeData (key: string) {
        try {
            window.sessionStorage.removeItem(key);
            return true;
        }
        catch(error) {
            console.log("Cannot remove local storage data. Data key: " + key);
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/services/SessionStorageService.ts